import React from "react";
import { Info } from "lucide-react";

// Minimum points required before a window stops showing the
// "DATA ACCUMULATING" notice. Tuned to the days-per-window ratio:
//   1W → 7 days expected, surface notice until >= 3 days collected
//   1M → 30 days expected, surface notice until >= 7 days collected
const MIN_POINTS = { "1w": 3, "1m": 7 };
const EXPECTED_POINTS = { "1w": 7, "1m": 30 };

export const DataAccumulatingNotice = ({ window, pointCount = 0, testId = "data-accumulating-notice" }) => {
  if (window !== "1w" && window !== "1m") return null;
  if (pointCount >= (MIN_POINTS[window] || 0)) return null;
  const label = window === "1w" ? "7 days" : "30 days";
  const expected = EXPECTED_POINTS[window] || 0;
  return (
    <div
      className="flex items-start gap-2 border px-3 py-2 mb-3"
      style={{
        borderColor: "color-mix(in srgb, var(--secondary-accent) 55%, transparent)",
        background: "color-mix(in srgb, var(--secondary-accent) 10%, transparent)",
        borderRadius: 2,
      }}
      data-testid={testId}
    >
      <Info className="w-3.5 h-3.5 mt-0.5 shrink-0" style={{ color: "var(--secondary-accent)" }} />
      <span className="text-xs" style={{ color: "var(--text-primary)" }}>
        <span className="font-bold" style={{ color: "var(--secondary-accent)" }}>
          DATA ACCUMULATING ·
        </span>{" "}
        Only <span className="font-mono-hud tabular-nums">{pointCount}/{expected}</span> {label}{" "}
        of history collected so far. The chart will become richer as background
        rollups fill in over the coming days.
      </span>
    </div>
  );
};

export default DataAccumulatingNotice;
